import { Action } from '@ngrx/store';
import { QuoteHeader, QuoteDetail } from '@quorum/models/xs-resource';
import { QuoteHeaderQueryParameters } from '@quorum/models/xs-query';

import { Vehicle } from '@quorum/models/xs-resource';

export const GET_QUOTES_FROM_SERVER = '[FIXED OPERATIONS] Get Quotes From Server';
export class GetQuotesFromServer implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_QUOTES_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: QuoteHeaderQueryParameters) {}
}

export const GET_QUOTES_FROM_SERVER_SUCCESS = '[FIXED OPERATIONS] Get Quotes From Server Success';
export class GetQuotesFromServerSuccess implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_QUOTES_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: { quotes: QuoteHeader[] }) {}
}

export const GET_QUOTES_FROM_SERVER_FAILURE = '[FIXED OPERATIONS] Get Quotes From Server Failure';
export class GetQuotesFromServerFailure implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_QUOTES_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export const GET_QUOTE_FROM_SERVER = '[FIXED OPERATIONS] Get Quote From Server';
export class GetQuoteFromServer implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_QUOTE_FROM_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: { id: number; query: QuoteHeaderQueryParameters }) {}
}

export const GET_QUOTE_FROM_SERVER_SUCCESS = '[FIXED OPERATIONS] Get Quote From Server Success';
export class GetQuoteFromServerSuccess implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_QUOTE_FROM_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: { quote: QuoteHeader }) {}
}

export const GET_QUOTE_FROM_SERVER_FAILURE = '[FIXED OPERATIONS] Get Quote From Server Failure';
export class GetQuoteFromServerFailure implements Action {
  readonly feature = 'fixedOperations';
  readonly type = GET_QUOTE_FROM_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export const POST_QUOTE_CASE_TO_SERVER = '[FIXED OPERATIONS] Post Quote Case To Server';
export class PostQuoteCaseToServer implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_QUOTE_CASE_TO_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: { case: QuoteDetail }) {}
}

export const POST_QUOTE_CASE_TO_SERVER_SUCCESS = '[FIXED OPERATIONS] Post Quote Case To Server Success';
export class PostQuoteCaseToServerSuccess implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_QUOTE_CASE_TO_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: { case: QuoteDetail }) {}
}

export const POST_QUOTE_CASE_TO_SERVER_FAILURE = '[FIXED OPERATIONS] Post Quote Case To Server Failure';
export class PostQuoteCaseToServerFailure implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_QUOTE_CASE_TO_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export const POST_QUOTE_AND_CASE_TO_SERVER = '[FIXED OPERATIONS] Post Quote And Case To Server';
export class PostQuoteAndCaseToServer implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_QUOTE_AND_CASE_TO_SERVER;
  readonly triggerStorageSync = false;
  constructor(public payload: { header: QuoteHeader; case: QuoteDetail }) {}
}

export const POST_QUOTE_AND_CASE_TO_SERVER_SUCCESS = '[FIXED OPERATIONS] Post Quote And Case To Server Success';
export class PostQuoteAndCaseToServerSuccess implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_QUOTE_CASE_TO_SERVER_SUCCESS;
  readonly triggerStorageSync = false;
  constructor(public payload: { case: QuoteDetail }) {}
}

export const POST_QUOTE_AND_CASE_TO_SERVER_FAILURE = '[FIXED OPERATIONS] Post Quote And Case To Server Failure';
export class PostQuoteAndCaseToServerFailure implements Action {
  readonly feature = 'fixedOperations';
  readonly type = POST_QUOTE_CASE_TO_SERVER_FAILURE;
  readonly triggerStorageSync = false;
  constructor(public payload: { error: any }) {}
}

export type QuotesAction =
  | GetQuotesFromServer
  | GetQuotesFromServerSuccess
  | GetQuotesFromServerFailure
  | GetQuoteFromServer
  | GetQuoteFromServerSuccess
  | GetQuoteFromServerFailure
  | PostQuoteCaseToServer
  | PostQuoteCaseToServerSuccess
  | PostQuoteCaseToServerFailure
  | PostQuoteAndCaseToServer
  | PostQuoteAndCaseToServerSuccess
  | PostQuoteAndCaseToServerFailure;
